export const QA_NAME_CALENDAR_GRID_DAY_POPOVER_ROW_SUB_ITEM =
  'calendarGridDayPopoverRowSubItem'
